import React from 'react';

const EducationPlatformSection = () => {
  return (
    <div className="bg-white text-center flex-1 flex flex-col p-[40px] rounded-[20px] shadow-[0_15px_45px_rgba(0,0,0,0.2)] transition-transform duration-300 hover:-translate-y-[10px] hover:shadow-[0_20px_50px_rgba(0,0,0,0.25)]">
      <h2 className="text-texto-oscuro font-extrabold text-[2.2rem] mb-[15px]">Plataforma Educativa</h2>
      <p className="text-texto-sec flex-grow text-base leading-[1.6] mb-[30px]">
        Accede a una ruta formativa con cursos y microlearning para tu desarrollo integral.
      </p>
      <ul className="list-none p-0 text-left flex flex-col mx-0 mb-[30px] gap-[15px]">
        {[
          'Bienestar emocional y manejo del estrés.',
          'Plan de vida y proyecto personal.',
          'Inteligencia emocional y resiliencia.',
          'Bienestar digital y autocuidado.',
        ].map((item) => (
          <li key={item} className="relative text-base pl-[28px]">
            <span className="absolute left-0 text-icetex font-bold">✓</span>
            {item}
          </li>
        ))}
      </ul>
      <a
        href="https://moodle.cursosvirtualesicetex.com/"
        target="_blank"
        rel="noopener noreferrer"
        className="bg-icetex text-white border-0 uppercase font-bold cursor-pointer no-underline inline-block py-[15px] px-[30px] rounded-[50px] text-[0.9rem] tracking-[0.5px] self-center shadow-[0_4px_15px_rgba(0,63,129,0.4)] transition-all duration-300 hover:bg-texto-oscuro hover:-translate-y-[3px]"
      >
        Explora la plataforma
      </a>
    </div>
  );
};

export default EducationPlatformSection;
